import * as actionTypes from '../actions/allActionList';
import { languagesAvailable } from '../../config/locales/languages-available';

function setDefaultLang() {
  const browserLanguages = window.navigator.languages;

  for (let i = 0; i < browserLanguages.length; i++) {
    for (let j = 0; j < languagesAvailable['en'].length; j++) {
      if (languagesAvailable['en'][j].isoCode === browserLanguages[i])
        return browserLanguages[i];
    }
  }

  return 'it';
}

const initialState = {
  langLocale: setDefaultLang(),
  isGoogleTranslateAvailable: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LANGUAGE:
      return {
        ...state,
        langLocale: action.lang,
      };
    case actionTypes.SET_GTRANSLATE_TO_UNAVAILABLE:
      return {
        ...state,
        isGoogleTranslateAvailable: false,
      };
    default:
      return state;
  }
};

export default reducer;
